/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IconAsset } from '../../models/icon-asset';

export interface DeleteIconAsset$Params {
  ref: string;
}

export function deleteIconAsset(http: HttpClient, rootUrl: string, params: DeleteIconAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<IconAsset>> {
  const rb = new RequestBuilder(rootUrl, deleteIconAsset.PATH, 'delete');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IconAsset>;
    })
  );
}

deleteIconAsset.PATH = '/v1/api/admin-ui/icon-asset/delete/{ref}';
